// Иконки — только lucide (правило @orbis/conformance). Здесь — словарь имён, которыми пользуется интерфейс.
import {
  Clock,
  FileText,
  Image,
  Paperclip,
  Upload,
  ArrowRight,
  ArrowUp,
  Bell,
  BellOff,
  BookOpen,
  Bot,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsUp,
  Circle,
  CircleAlert,
  Copy,
  CornerDownRight,
  Dot,
  ExternalLink,
  Flag,
  GitBranch,
  Inbox,
  KeyRound,
  Link,
  List,
  LoaderCircle,
  LogOut,
  Menu,
  MessageSquare,
  Monitor,
  Moon,
  Network,
  Pause,
  Pencil,
  Pin,
  Play,
  Plus,
  Radio,
  RefreshCw,
  Search,
  Send,
  Server,
  Settings,
  Shield,
  Square,
  SquareCheck,
  SquareKanban,
  Star,
  Sun,
  Trash2,
  TriangleAlert,
  User,
  Wrench,
  X,
  Zap,
  type LucideIcon,
} from 'lucide-react'

const ICONS = {
  plus: Plus,
  x: X,
  search: Search,
  chevronDown: ChevronDown,
  chevronRight: ChevronRight,
  chevronLeft: ChevronLeft,
  chevronsUp: ChevronsUp,
  arrowUp: ArrowUp,
  arrowRight: ArrowRight,
  pause: Pause,
  play: Play,
  sun: Sun,
  moon: Moon,
  monitor: Monitor,
  refresh: RefreshCw,
  external: ExternalLink,
  copy: Copy,
  check: Check,
  clock: Clock,
  alert: TriangleAlert,
  alertCircle: CircleAlert,
  flag: Flag,
  menu: Menu,
  logout: LogOut,
  send: Send,
  trash: Trash2,
  edit: Pencil,
  pin: Pin,
  tool: Wrench,
  bolt: Zap,
  inbox: Inbox,
  link: Link,
  graph: Network,
  list: List,
  dot: Dot,
  circle: Circle,
  message: MessageSquare,
  user: User,
  star: Star,
  shield: Shield,
  git: GitBranch,
  kanban: SquareKanban,
  bot: Bot,
  radio: Radio,
  book: BookOpen,
  settings: Settings,
  bell: Bell,
  bellOff: BellOff,
  square: Square,
  squareCheck: SquareCheck,
  key: KeyRound,
  cornerDownRight: CornerDownRight,
  loader: LoaderCircle,
  server: Server,
  paperclip: Paperclip,
  file: FileText,
  image: Image,
  upload: Upload,
} satisfies Record<string, LucideIcon>

export type IconName = keyof typeof ICONS

export function Icon({
  name,
  size = 16,
  className,
  strokeWidth = 1.8,
}: {
  name: IconName
  size?: number
  className?: string
  strokeWidth?: number
}) {
  const Cmp = ICONS[name]
  return <Cmp size={size} strokeWidth={strokeWidth} className={className} aria-hidden="true" focusable="false" />
}
